export const PROCESSING_DRIVER_PENALTY = "PROCESSING_DRIVER_PENALTY";
export const PROCESSING_BULK_DRIVER_PENALTY = "PROCESSING_BULK_DRIVER_PENALTY";
export const GET_DRIVER_PENALTY = "GET_DRIVER_PENALTY";
export const CREATE_DRIVER_PENALTY = "CREATE_DRIVER_PENALTY";
export const DELETE_DRIVER_PENALTY = "DELETE_DRIVER_PENALTY";
